/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'blurb-content-for-ngo',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    openNgoSignupPopup(){
      bus.$emit('ngoSignUpFormPopupBus', true);
      bus.$emit('ngoBlurbContentPopupBus', false);
    },
    blurbTextPopupClosed(){
      bus.$emit('ngoBlurbContentPopupBus', false);
      document.body.classList.remove('popup_open_body')
    }
  }
}